import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../../resources/types'

const ContactSignalCreateInputsSchema = z.object({
  'contact-id': z.string().describe('Contact to add the signal to'),
  description: z
    .string()
    .describe(
      'Short signal description shown before "via" and the app, e.g. "Booked an appointment"',
    ),
  'app-handle': z
    .string()
    .describe('App handle used to resolve app icon and display name'),
  handle: z
    .string()
    .optional()
    .describe(
      'Stable signal handle for routing (e.g. member-signed-up). Used by thread.signal.created event subscriptions to filter signals.',
    ),
  metadata: z
    .record(z.string(), z.unknown())
    .optional()
    .describe(
      'Additional signal payload stored on the contact block (event data, IDs, etc.)',
    ),
})

const ContactSignalCreateOptionsSchema = z.object({})

export const ContactSignalCreateCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/conversations'),
    cmd: z.literal('contact.signal.create'),
    options: ContactSignalCreateOptionsSchema.optional(),
  }),
  inputs: ContactSignalCreateInputsSchema,
})

export type ContactSignalCreateCommand = z.infer<
  typeof ContactSignalCreateCommandSchema
>
